import React, { Component } from "react";
import {
  Table,
  Button,
  FormGroup,
} from "reactstrap";
import { reduxForm, Field } from 'redux-form'
import { connect } from 'react-redux';
import BlockUi from 'react-block-ui';
import Moment from "react-moment";
import 'react-block-ui/style.css';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import DisplayRecordText from "../../controls/_DisplayRecordText"
import Pagination from 'react-js-pagination';
import EditUser from './_EditUser';
import AddUser from './_AddUser';
import { storedb } from '../../../views/client/storedb'

import * as adminActions from './actions';
import UserAdTypes from './constants'

var dbContext;

class UserAd extends Component {
  constructor(props) {
    super(props);

    dbContext = storedb();
    this.state = {
      modalEdit: false,
      modalAdd: false,
      list: [],
      item: {},
      keyword: '',
      total_record: 0,
      page: 1,
      per_page: 20,
    };
  }

  fetchList = (page) => {
    const { userAdListRequest } = this.props

    var requestData = {
      keyword: this.state.keyword,
      page: page || this.state.page,
      per_page: this.state.per_page
    }

    return userAdListRequest(requestData)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.userAdList.type === UserAdTypes.LIST_SUCCESS) {
      let list = nextProps.userAdList.listData.records;
      let total_record =  nextProps.userAdList.listData.total_record;
      let per_page =  nextProps.userAdList.listData.per_page;
      this.setState({ list ,total_record, per_page});
    }
    if (nextProps.userAdList.type === UserAdTypes.ITEM_REMOVE_SUCCESS) {
      this.fetchList()
    }
  }

  handleSearchChange = (evt) => {
    this.setState({
      keyword: evt.target.value
    });
  }
  keyPress = (e) => {
    if(e.keyCode == 13){
       this.search()
    }
  }
  toggleAdd = () => {
    if (!this.state.modalAdd) {
      this.setState(() => ({
        modalAdd: true,
      }));
    }
    else {
      //close 
      this.setState(() => ({
        modalAdd: false,
      }));
      this.props.adminUserResetData();
    }
  }

  toggleEdit = (obj) => {
    if (!this.state.modalEdit) {
      let requestForm = {
        username: obj.username,
      }
      this.props.adminUserItemRequest(requestForm);
      this.setState(() => ({
        modalEdit: true,
      }));
    }
    else {
      //close 
      this.setState(() => ({
        item: {},
        modalEdit: false,
      }));

      this.props.adminUserResetData();
    }
  }

  processRemoveItem = (item) => {
    const requestForm = {
      username: item.username,
    }
    this.props.adminUserRemoveItemRequest(requestForm);
  }
  handleRoleChange = (values) => {
    this.props.adminUserSetDataForItem("permissions", values);
  }
  removeItem = (item) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>THÔNG BÁO?</h1>
            <p>Bạn có muốn xóa nhân viên <b className="text-danger">{item.TenDayDu}</b> này không?<br />
              Việc này đồng nghĩa nhân viên này không thể sử dụng được phần mềm nữa.
            </p>
            <button className="text-danger" onClick={() => {
              this.processRemoveItem(item);
              onClose()
            }}>Đồng ý</button>
            <button onClick={onClose}>Hủy bỏ</button>
          </div>
        )
      }
    });
  }

  search = () => {
    if (this.props.userAdList.listRequesting) {
      return false;
    }
    this.setState({ page: 1 }, () => this.fetchList(1));
  }
  onChangeItem = (itemPerPage) => {
    this.setState({ per_page: itemPerPage }, () => {
      this.search();
    });
  }
  handlePageChange = (pageNumber) => {
    let page = parseInt(pageNumber || 1)
    return this.setState({ page }, this.fetchList);
  }
  componentDidMount() {
    this.fetchList()
  }

  render() {
    const { list } = this.state
    const {
      handleSubmit,
      userAdList: {
        listRequesting,
        requesting,
        messages,
        errors,
        item,
      },
    } = this.props
    const dataUser = item.user || {};
    const startIndex = (this.state.page - 1) * this.state.per_page
    
    return (
      <div className="animated fadeIn">
        <div className="row col-sm-12 pl-0 pr-0">
          <div className="col-sm-6 mb-1 pull-left">
            <FormGroup>
              <Field type="text" name="keyword" placeholder="Tài khoản, Tên, điện thoại, địa chỉ" 
                className={"form-control"} 
                onChange={e => this.handleSearchChange(e)} 
                onKeyDown={e => this.keyPress(e)}
                component="input" />
            </FormGroup>
          </div>
          <div className="col-sm-6 mb-1 pull-left">
            <div className="btn-group" role="group">
              <Button className="btn btn-success mr-1" onClick={handleSubmit(this.search)}><i className="fa fa-search"></i>&nbsp;Tìm kiếm</Button>
              <Button className="btn btn-secondary" onClick={e => this.toggleAdd(e)}><i className="fa fa-plus"></i>&nbsp;Thêm tài khoản </Button>
            </div>
          </div>
        </div>
        <BlockUi tag="div" blocking={listRequesting}>
          <div className="mt-2 bg-white">
            <div className="col-sm-12 pr-0 pl-0">

              <div className="w-100">
                <DisplayRecordText
                  itemsCountPerPage={this.state.per_page}
                  onChangeItem={this.onChangeItem}
                />

                <Table hover responsive className="table-outline table-sm mb-0 d-sm-table table table-hover">
                  <thead className="thead-default">
                    <tr>
                      <th scope="col" width="50">#</th>
                      <th scope="col" width="120">Tài khoản</th>
                      <th scope="col">Tên</th>
                      <th scope="col">Địa chỉ</th>
                      <th scope="col" width="100" className="text-center">Điện thoại</th>
                      <th scope="col" width="120" className="text-center">Đ/nhập cuối</th>
                      <th scope="col" width="80" className="text-center">Trạng thái</th>
                    </tr>
                  </thead>
                  <tbody>
                    {list && !!list.length && (
                      list.map((res, idx) => (
                        <tr key={idx + 1}>
                          <td>{startIndex + (idx + 1)}</td>
                          <td> <button className="btn btn-link pl-0" onClick={e => this.toggleEdit(res)}>{res.username}</button> </td>
                          <td>
                            <button className="btn btn-link pl-0" onClick={e => this.toggleEdit(res)}>{res.ten_day_du}</button>
                          </td>
                          <td className="text-left">{res.dia_chi}</td>
                          <td className="text-center">{res.dien_thoai}</td>
                          <td className="text-center">
                            {res.login_at && <Moment format="HH:mm DD/MM/YYYY" tz="UTC">{`${res.login_at}`}</Moment>}
                          </td>
                          <td className="text-center">
                          {res.is_active && (
                            <i className="fa fa-check fa-3 text-success"></i>
                          )}
                          {!res.is_active && (
                            <i className="fa fa-close fa-3 text-dancer"></i>
                          )}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan="7">
                        <span className="text-success mr-2"><i className="fa fa-check"></i> = Đang hoạt động</span>
                        <span className="text-danger"><i className="fa fa-close"></i> = Dừng hoạt động</span>
                      </td>
                    </tr>
                  </tfoot>
                </Table>
                {this.state.total_record > this.state.per_page && (
                  <nav>
                    <Pagination
                      activePage={this.state.page}
                      itemsCountPerPage={this.state.per_page}
                      totalItemsCount={this.state.total_record}
                      pageRangeDisplayed={5}
                      onChange={this.handlePageChange}
                    />
                  </nav>
                )}
                {/* Modal */}
                <EditUser
                  adminUserSetDataForUser={this.props.adminUserSetDataForUser}
                  resetError={this.props.resetError}
                  adminUserSetErrors={this.props.adminUserSetErrors}
                  parentProps={this.props}
                  handleSubmit={handleSubmit}
                  requesting={requesting}
                  messages={messages}
                  errors={errors}
                  data={dataUser}
                  isEditing={this.state.modalEdit}
                  updateUser={this.props.adminUserItemUpdateRequest}
                  fetchList={() => {
                    this.fetchList();
                  }}
                  onClose={this.toggleEdit}
                  resetDataItem={this.props.resetDataItem}/>
                <AddUser
                  adminUserSetDataForUser={this.props.adminUserSetDataForUser}
                  resetError={this.props.resetError}
                  adminUserSetErrors={this.props.adminUserSetErrors}
                  parentProps={this.props}
                  handleSubmit={handleSubmit}
                  requesting={requesting}
                  messages={messages}
                  errors={errors}
                  data={dataUser}
                  isAdding={this.state.modalAdd}
                  addUser={this.props.adminUserItemAddRequest}
                  fetchList={() => {
                    this.fetchList();
                  }}
                  onClose={this.toggleAdd}/>
                {/* End Modal */}

              </div>
            </div>
          </div>
        </BlockUi>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  userAdList: state.userAdList,
  client: state.client,
})

const connected = connect(mapStateToProps,
  {
    adminUserSetDataForItem: adminActions.adminUserSetDataForItem,
    userAdListRequest: adminActions.userAdListRequest,
    adminUserItemRequest: adminActions.adminUserItemRequest,
    adminUserItemAddRequest: adminActions.adminUserItemAddRequest,
    adminUserItemUpdateRequest: adminActions.adminUserItemUpdateRequest,
    adminUserSetError: adminActions.adminUserSetError,
    adminUserSetErrors: adminActions.adminUserSetErrors,
    adminUserSetDataForUser: adminActions.adminUserSetDataForUser,
    adminUserRemoveItemRequest: adminActions.adminUserRemoveItemRequest,
    adminUserResetData: adminActions.adminUserResetData,
    resetError: adminActions.resetError,

  })(UserAd)

const formed = reduxForm({
  form: 'userAdList',
})(connected)

export default formed;



// WEBPACK FOOTER //
// ./src/views/Admin/UserAd/UserAd.js